import { IDealDocument } from '@/dealboard/types/deal-document';
import { IDealEvent } from '@/dealboard/types/deal-event';
import { IDealEvents } from '@/dealboard/types/deal-events';
import { IDealUser } from '@/dealboard/types/deal-user';
import { IDealDTO } from '@/dealboard/types/dtos/deal-response-dto';
import { IDeal } from '@/dealboard/types/deal';
import { IRecipient } from '@/types/Recipient';
import { IRecipientResponse } from '@/types/responses/RecipientResponse';
export function convertDealsReponse(deals: IDealDTO[] = []): IDeal[] {
  return deals.map(
    (deal: IDealDTO) =>
      ({
        document: {
          companyLogoUrl: deal.document.company_logo_url,
          companyName: deal.document.company_name,
          created: deal.document.created_at,
          expirationDate: deal.document.expiration_date,
          id: deal.document.id,
          isAccelerator: deal.document.is_accelerator,
          isHot: deal.document.is_hot,
          isRejected: deal.document.is_rejected,
          isReminderSending: deal.document.is_reminder_sending,
          isVod: deal.document.is_vod,
          name: deal.document.name,
          partlyRejected: deal.document.partly_rejected,
          partlyReviewed: deal.document.partly_reviewed,
          partlySigned: deal.document.partly_signed,
          partlyViewed: deal.document.partly_viewed,
          rejectedCount: deal.document.rejected_count,
          reviewedCount: deal.document.reviewed_count,
          scoreClass: deal.document.score_class,
          scoreExplanation: deal.document.score_explanation,
          scoreValue: deal.document.score_value,
          sendDate: deal.document.send_date,
          signedCount: deal.document.signed_count,
          signerCount: deal.document.signer_count,
          status: deal.document.status,
          type: deal.document.type,
          value: deal.document.value,
          viewedCount: deal.document.viewed_count,
        } as IDealDocument,
        events:
          deal.events &&
          ({
            reviewed: deal.events.reviewed,
            verified: deal.events.verified,
            viewed: deal.events.viewed,
            forwarded: deal.events.forwarded,
            downloaded: deal.events.downloaded,
            printed: deal.events.printed,
            commented: deal.events.commented,
            sent: deal.events.sent,
            signed: deal.events.signed,
            rejected: deal.events.rejected,
          } as IDealEvents),
        lastEvent:
          deal.last_event &&
          ({
            name: deal.last_event.event_name,
            date: deal.last_event.event_date,
          } as IDealEvent),
        recipients: deal.recipients.map(
          (recipient: IRecipientResponse) =>
            ({
              email: recipient.email,
              firstName: recipient.first_name,
              gender: recipient.gender,
              lastName: recipient.last_name,
              role: recipient.recipient_role,
              recipientStatus: recipient.recipient_status,
              thumbUrl: recipient.thumb_url,
            } as IRecipient)
        ),
        user: {
          firstName: deal.user.first_name,
          lastName: deal.user.last_name,
          thumbUrl: deal.user.thumb_url,
        } as IDealUser,
      } as IDeal)
  );
}
